import { useGeckoPermissions } from 'features/permissions'
import {
  PERMISSION_CANTILEVER_POWER_MODEL_BUILDER_EDITOR,
  PERMISSION_GECKO_INTERNAL_MEMBER,
  RolodexPermissionsValues,
} from 'types'

export const MODEL_BUILDER_PERMISSIONS: RolodexPermissionsValues[] = [
  PERMISSION_GECKO_INTERNAL_MEMBER,
  PERMISSION_CANTILEVER_POWER_MODEL_BUILDER_EDITOR,
]

export interface ModelBuilderAccess {
  canUseModelBuilder: boolean
  canManageAlerts: boolean
}

/**
 * The model builder (Models button, Agent tab, model dock) opens to Gecko staff
 * and to holders of `cantilever:power-model-builder:editor`. Arming a monitor
 * and opening cases stay staff-only.
 */
export const getModelBuilderAccess = (
  hasPermissions: (permissions: RolodexPermissionsValues[]) => boolean
): ModelBuilderAccess => ({
  canUseModelBuilder: hasPermissions(MODEL_BUILDER_PERMISSIONS),
  canManageAlerts: hasPermissions([PERMISSION_GECKO_INTERNAL_MEMBER]),
})

export const useModelBuilderAccess = (): ModelBuilderAccess => {
  const { hasPermissions } = useGeckoPermissions()
  return getModelBuilderAccess(hasPermissions)
}
